import { CUSTOMER_ERROR,CUSTOMER_SUCCESS,EDIT_CUSTOMER } from './actionTypes';

const initialState = {
    error: "",
    success : ""
}

const Customer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_CUSTOMER:
            state = { ...state }
            break;
        case CUSTOMER_SUCCESS:
            state = { ...state, success: action.payload }
            break;
        case CUSTOMER_ERROR:
            state = { ...state, error: action.payload };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default Customer;